import "@babel/polyfill";
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'es5-shim';
import 'console-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from './serviceWorker';
import { history } from './history';
import Root from './root.LB';
import configureStore from './LB/redux/store/store';
import './LB/assets/global.scss';
import './indexLB.css'
// import 'babel-preset-env';

// set initial state in store
const { store, persistor } = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Root history={history} />
        </PersistGate>
    </Provider>
    ,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); 